<template>
  <div class="subsection" v-if="selectedVendorProject">
    <div
      class="table-data__tool clearfix"
      style="
      background: rgb(214, 213, 213);
    border: 1px solid #e2e2e2;
    padding: 5px 10px;"
    >
      <!-- <div class="float-left">
        <button
              class="sideB bLightBlue">( {{ vendor.name }} ) Contact List</button>
      </div>-->
      <div class="float-right">
        <button class="sideB bLightBlue" @click="createItem()" v-if="hasPermission('create vendorproject')">
          <i class="zmdi zmdi-plus"></i> Add New Price
        </button>
      </div>
    </div>
    <DataTable
      ref="datatable"
      :settings="datatable.settings"
      :dataColumns="datatable.columns"
      :dataFeed="datatable.dataFeed"
      :dataHandle="datatable.handle"
      :dataTableHeight="datatable.height"
      :defaultSortBy="datatable.sortBy"
      :defaultOrderBy="datatable.orderBy"
      :customViewItem="viewItem"
      :customEditItem="editItem"
      :allowView="allowView"
      :allowEdit="allowEdit"
      :allowDelete="allowDelete"
      :hasContextMenu="hasContextMenu"
    >
      <template slot="menuButtons" slot-scope="props">
        <template v-if="props.item && props.item.data">
          <li @click="$refs.datatable.viewItem($event, props.item.data)" v-if="allowView(props.item.data)">View</li>
          <li @click="$refs.datatable.editItem($event, props.item.data)" v-if="allowEdit(props.item.data)">Edit</li>
          <li @click="$refs.datatable.confirmDelete($event, props.item.data)" v-if="allowDelete(props.item.data)">Delete</li>
        </template>
      </template> 
    </DataTable>
    <VendorProjectHistoryEdit
      :formMode="formMode"
      :formShow="isEditing"
      :selectedVendorProject="selectedVendorProject"
      :selectedItem="selectedItem"
      @closeVendorProjectHistoryEdit="closeVendorProjectHistoryEdit"
      @reload="reload"
    />
  </div>
</template>
<script>
import VendorProjectHistoryEdit from "./VendorProjectHistoryEdit";

export default {
  name: "VendorProjectHistory",
  components: {
    VendorProjectHistoryEdit
  },
  props: {
    selectedVendorProject: Object
  },
  data() {
    return {
      selectedItemContact: [],
      datatable: {
        settings: {
          sectionName: "vendor",
          webService: this.$root.WebService.vendorprojectHistory
        },
        dataFeed: null,
        handle: null,
        columns: [
          { key: 'created_at', title: "Price Date", type: "input", width: "12%", value: null },
          { key: 'display_price', title: "Unit Price", type: "input", width: "12%", value: null, datafilter: this.$options.filters.numberFormat },
          { key: 'terms', title: "Terms", type: "input", width: "12%", value: null },
          { key: 'quantity', title: "Quantity", type: "input", width: "12%", value: null, datafilter: this.$options.filters.numberFormat },
          { key: 'remarks', title: "Remarks", type: "input", width: "52%", value: null },
        ],
        sortBy: null,
        orderBy: "desc",
        height: "60vh",
      },
      datas: [],
      filteredDatas: [],
      isEditing: false,
      selectedItem: null,
      formMode: null
    };
  },
  mounted() {
    this.datatable.handle = (res) => this.datas = res.data.data
    this.datatable.dataFeed = {
      method: 'get',
      url: this.WebService.vendorproject + '/' + this.selectedVendorProject.id + '/history'
    }
  },
  methods: {
    viewItem(item) {
      this.formMode = 'view'
      this.isEditing = true
      this.selectedItem = item
    },
    editItem(item) {
      this.formMode = 'edit'
      this.isEditing = true
      this.selectedItem = item
    },
    createItem() {
      this.formMode = 'create'
      this.isEditing = true
    },
    closeVendorProjectHistoryEdit() {
      this.formMode = null
      this.isEditing = false
      this.selectedItem = null
    },
    allowView(item) {
      return this.hasPermission('read vendorproject')
    },
    allowEdit(item) {
      return this.hasPermission('update vendorproject')
    },
    allowDelete(item) {
      return this.hasPermission('delete vendorproject')
    },
    hasContextMenu(item) {
      return this.allowView(item) || this.allowEdit(item) || this.allowDelete(item)
    },
    reload() {
      this.$refs.datatable.reload()
      this.$emit('reloadParent', null, this.selectedVendorProject)
    }
  }
};
</script>